(function($) {  

  let $shortcodeSCR = $('.ShortCode.Resources')
  if($shortcodeSCR.length) { 

    $downloads = $shortcodeSCR.find('.Download')

    $downloads.attr('target', 'Resource')
  }

})(jQuery)